import * as angular from 'angular';

"use strict";

angular.module('PreventTemplateCacheModule', []);

export default 'PreventTemplateCacheModule';